import React from 'react'
import '../Styles/ContactPage.css'

function ContactPage() {
  return (
    <div className="contact-container">
      <h className="contact-header">Contact Us</h>
      <p className="contact-context">Have questions? <br></br> We'd love to hear from you.</p>
      <a href="mailto:contact@berealtimelapse.com" className="contact-email">contact@berealtimelapse.com</a>
    </div>
  )
}

export default ContactPage;